import React from 'react';
import { BsTwitter } from 'react-icons/bs';
import { BsGithub, BsLinkedin } from 'react-icons/bs';

const SocialMedia = () => {
  return (
    <div className="app__social md:p-[1rem]">
      <div className="">
        <a
          href="https://twitter.com/Omesha_Sh"
          target={'_blank'}
          rel="noreferrer"
        >
          <BsTwitter />
        </a>
      </div>
      <div className="">
        <a href="https://github.com/Omeshcoding" target={'_blank '}>
          <BsGithub />
        </a>
      </div>
      <div className="">
        <a
          href="https://www.linkedin.com/in/umesh-sharma-aa6674131/"
          target={'_blank'}
          rel="noreferrer"
        >
          <BsLinkedin />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
